export function voiceDuration(voiceDuration) {
    if(voiceDuration != null){
        let hours = parseInt((voiceDuration % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = '' + parseInt((voiceDuration % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = '' + parseInt((voiceDuration % (1000 * 60)) / 1000)
        if (minutes.length < 2) {
            minutes = '0' + minutes;
        }
        if (seconds.length < 2) {
            seconds = '0' + seconds;
        }
        if(hours > 0){
            hours = '' + hours;
            if (hours.length < 2) {
                hours = '0' + hours;
            }
            return [hours, minutes, seconds].join(':');
        }
        return [minutes, seconds].join(':');
    }
}